import {default as Avaria} from './avaria/routes'
import {default as estadoVeiculo} from './estado-veiculo/routes'

export default [
  ...Avaria,
  ...estadoVeiculo
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/veiculo/routes.js